import { render } from "./TabItem.vue?vue&type=template&id=698de3a2&scoped=true"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"

import "./TabItem.vue?vue&type=style&index=0&id=698de3a2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698de3a2"]])

export default __exports__